// Trap Focus
function trapFocus (element, excludingIn) {
  const KEYCODE_TAB = 9
  element.addEventListener('keydown', function (e) {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB)

    if (!isTabPressed) {
      return
    }

    const focusableEls = Array.from(element.querySelectorAll('a[href]:not(' + excludingIn + ' a), button:not(' + excludingIn + ' textarea):not([disabled]), .tabs a:not(' + excludingIn + ' a):not(.tabs a[aria-selected="false"]):not([disabled]), textarea:not(' + excludingIn + ' textarea):not([disabled]), input[type="text"]:not(' + excludingIn + ' input):not([disabled]), input[type="radio"]:not(' + excludingIn + ' input):not([disabled]), input[type="checkbox"]:not(' + excludingIn + ' input):not([disabled]), input[type="search"]:not(' + excludingIn + ' input):not([disabled]), input[type="submit"]:not(' + excludingIn + ' input):not([disabled]), select:not(' + excludingIn + ' select):not([disabled])'))
    if (focusableEls[0].classList.contains('back-button') && !focusableEls[0].classList.contains('active')) {
      focusableEls.shift()
    }

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (e.shiftKey) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault()
        lastFocusableEl.focus()
      }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault()
        firstFocusableEl.focus()
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  // Variables
  const videoBlocks = document.querySelectorAll('.content-media__media-video')

  for (let i = 0; i < videoBlocks.length; i++) {
    const video = videoBlocks[i]
    const button = video.querySelector('.content-media__video-button ')
    const closeButton = video.querySelector('.content-media__close-player')
    const videoPlayer = video.querySelector('.content-media__video-player')

    button.addEventListener('click', function () {
      video.classList.add('content-media--playing')
      trapFocus(videoPlayer)
      button.setAttribute('aria-expanded', true)
      closeButton.setAttribute('aria-expanded', true)
      videoPlayer.setAttribute('aria-hidden', false)

      setTimeout(() => {
        closeButton.focus()
      }, 50)
    })

    closeButton.addEventListener('click', function () {
      video.classList.remove('content-media--playing')
      button.setAttribute('aria-expanded', false)
      closeButton.setAttribute('aria-expanded', false)
      videoPlayer.setAttribute('aria-hidden', true)

      setTimeout(() => {
        button.focus()
      }, 50)
    })
  }
})
